






























import {Vue, Component, Emit, Prop} from "vue-property-decorator";
import RestcommNumbers from "@/consoleapi/api/restcomm/numbers";
import PhoneNumber from "@/consoleapi/api/number";
import ResponseMessenger from "@/consoleapi/messages/responseMessenger";
interface Applied{
  phone_number: string;
}
@Component
export default class CreateIncomingPhoneNumberModal extends Vue {
  private incomingNumbers = [];
  private selectedNumber = null;
  /**
   *
   */
  @Prop()
  appliedNumbers!: Array<Applied>
  private messages: ResponseMessenger;

  constructor() {
    super();
    this.messages = new ResponseMessenger();
  }

  addNumber() {
    const phoneNumber = this.selectedNumber;
    if (phoneNumber === null) {
      return;
    }
    const number = new RestcommNumbers();
    number.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
    number.apply(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)), phoneNumber)
        .then(response => {
          console.log(response.data);
          alert('電話番号を追加しました');
          this.closeModalEmit();
        })
        .catch(error => {
          console.log(error.response);
          this.messages.parseMessageResponse(error.response);
          alert(this.messages.getTextMessage());
        })
  }

  getAvailableNumbers() {
    const number = new PhoneNumber();
    number.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
    number.getOwnNumbers(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)))
        .then(response => {
          console.log(response.data);
          this.incomingNumbers = response.data;
        })
        .catch(error => {
          console.log(error.response);
        });
  }

  @Emit("close-modal")
  public closeModalEmit() {
    // console.log("test");
  }

  get AvailableNumbers() {
    const numbers: string[] = [];
    const response: object[] = [];
    let i: string;
    let j: string;
    for (i in this.appliedNumbers) {
      numbers.push(this.appliedNumbers[i]["phone_number"]);
    }
    for (j in this.incomingNumbers) {
      if (!numbers.includes(this.incomingNumbers[j]["number"])) {
        response.push(this.incomingNumbers[j]);
      }
    }
    return response;
  }

  mounted() {
    this.getAvailableNumbers();
    console.log('fae');
    console.log(this.appliedNumbers);
  }
}
